import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-new-certificate-error-banner',
  standalone: false,
  templateUrl: './new-certificate-error-banner.component.html',
  styleUrl: './new-certificate-error-banner.component.scss'
})
export class NewCertificateErrorBannerComponent {
  @Input() title = 'Request Failure';
  @Input() message = '';
  @Output() dismissed = new EventEmitter<void>();

  onDismiss(): void {
    this.dismissed.emit();
  }
}
